import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "react-query";

/* Old Contexts */
import { ClienteContextProvider } from "./context/ClienteContext";
import { CNDContextProvider } from "./context/CNDContext";
import { ImutaveisContextProvider } from "./context/ImutaveisContext";
import MarketplaceProvider from "./context/integracao/MarketplacesContext";

/* Routes */
import Routes from "./Routes";
import RoutesModules from "./routes/Index";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App(props) {
  useEffect(() => {
    console.log("Versão: 3.13.0  22/10/2025 17:30");

    console.log("Ambiente:", process.env.REACT_APP_AMBIENTE);
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <ImutaveisContextProvider>
        <MarketplaceProvider>
          <ClienteContextProvider>
            <CNDContextProvider>
              <Routes />
              <RoutesModules />
            </CNDContextProvider>
          </ClienteContextProvider>
        </MarketplaceProvider>
      </ImutaveisContextProvider>
    </QueryClientProvider>
  );
}

export default App;
